import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router';
import {
  normalizeCrmCustomerPaymentsReturnTo,
  PaymentsPage,
  paymentsSearchSchema,
} from '@pages/payments';

export const Route = createFileRoute('/$locale/_authenticated/payments')({
  validateSearch: paymentsSearchSchema,
  component: PaymentsRoute,
});

function PaymentsRoute() {
  const { locale } = Route.useParams();
  const search = Route.useSearch();
  const { tab } = search;
  const navigate = Route.useNavigate();
  const profileOriginCustomerId = search.profileOriginCustomerId;
  const profileOriginUserProfilePaymentsReturnTo = search.profileOriginUserProfilePaymentsReturnTo;
  const isPaymentDetail = useRouterState({
    select: (state) =>
      state.matches.some(
        (match) => match.routeId === '/$locale/_authenticated/payments/$paymentId'
      ),
  });
  if (isPaymentDetail) return <Outlet />;
  return (
    <PaymentsPage
      locale={locale}
      activeTab={tab ?? 'pricing'}
      q={search.q}
      userProfileId={search.userProfileId}
      profileOriginCustomerId={profileOriginCustomerId}
      profileOriginPaymentQ={search.profileOriginPaymentQ}
      profileOriginUserProfilePaymentsReturnTo={profileOriginUserProfilePaymentsReturnTo}
      onBack={
        profileOriginCustomerId
          ? () => {
              const returnTo = normalizeCrmCustomerPaymentsReturnTo(
                profileOriginUserProfilePaymentsReturnTo,
                profileOriginCustomerId
              );
              if (returnTo !== undefined) {
                void navigate({ to: returnTo as never });
                return;
              }
              void navigate({
                to: '/$locale/crm/user-profiles/$userProfileId/payments',
                params: { userProfileId: profileOriginCustomerId, locale },
                search: { paymentQ: search.profileOriginPaymentQ },
              });
            }
          : undefined
      }
      onOpenPayment={(paymentId, options) => {
        void navigate({
          to: '/$locale/payments/$paymentId',
          params: { locale, paymentId },
          search: {
            detailReturn: 'global',
            detailReturnGlobalUserProfileId: search.userProfileId,
            detailReturnProfileOriginCustomerId: search.profileOriginCustomerId,
            detailReturnProfileOriginPaymentQ: search.profileOriginPaymentQ,
            detailReturnProfileOriginUserProfilePaymentsReturnTo:
              profileOriginUserProfilePaymentsReturnTo,
            detailReturnQ: search.q,
            detailTab: options?.initialTab,
          },
        });
      }}
      onSearchQueryChange={(q) => {
        void navigate({
          replace: true,
          resetScroll: false,
          search: (current) => ({ ...current, q }),
        });
      }}
    />
  );
}
